import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import html2canvas from 'html2canvas';
import { _Api } from 'Ecommerce/common/api';
import Spinner from 'Ecommerce/common/Spinner';
import { toFormatPrice } from 'Ecommerce/common/Formateprice';
import RightArrow from 'admin/common/icons/right-arrow';
import CalendarIcon from 'admin/common/icons/sidebar/CalendarIcon';
import './cart.scss'
import PrintIcon from 'admin/common/icons/PrintIcon';
import useScreenSize from 'Ecommerce/template_four/include/Common/useScreenSize';
import BottomBar from 'Ecommerce/template_four/include/Common/BottomBar';
import ShareIcon from 'admin/common/icons/ShareIcon';
import DownloadIcon from 'admin/common/icons/DownloadIcon';
import DeleteIcon from 'admin/common/icons/DeleteIcon';
import PlusIcon from 'admin/common/icons/PlusIcon';
import MinusIcon from 'Ecommerce/common/icons/MinusIcon';
import Deletedeletepopup from 'Ecommerce/template_four/components/Delete/DeleteConfirmationPopup';
import HeartIcon from 'admin/common/icons/HeartIcon';
import MessageIcon from 'admin/common/icons/MessageIcon';


export default function ShoppinCart() {

    let shipdata = JSON.parse(localStorage.getItem('CartItems')) || []
    const { t } = useTranslation();
    const navigate = useNavigate()
    const [cartdata, setCartdata] = useState([])
    const [loading, setLoading] = useState(false)
    const [checkid, setCheckid] = useState([])
    const [isPopupVisible, setIsPopupVisible] = useState(false);
    const [singleDeleteItem, setSingleDeleteItem] = useState();
    const screenSize = useScreenSize();
    const [currency , setcurrency] = useState('$')
    const getQuantity = (index, lable, qty) => {
        let array = [...cartdata]
        if (lable === "plus") {
            array[index].qty = qty + 1
        } else if (lable === "minus") {
            array[index].qty = qty - 1
        }
        setCartdata(array)
        let setupdatearray = []
        array.forEach((result) => {
            setupdatearray.push({
                id: result?.id,
                qty: result?.qty
            })
        })

        if(setupdatearray?.length > 0 ){
            setCheckid(prevCheckid =>
                prevCheckid.map(item => {
                    const updateItem = setupdatearray.find(update => update?.id === item?.id);
                    return updateItem ? { ...item, qty: updateItem?.qty } : item;
                })
            );}
        // getcarts(setupdatearray)
        localStorage.setItem('CartItems', JSON.stringify(setupdatearray));
    }

    const deleteItems = (removeid) => {
        let array = [...cartdata]
        let update = array.filter(e => e?.id !== removeid);
        setCartdata(update);
        let setupdatearray = []
        update.forEach((result) => {
            setupdatearray.push({
                id: result?.id,
                qty: result?.qty
            })
        })
        localStorage.setItem('CartItems', JSON.stringify(setupdatearray));
        setSingleDeleteItem((prev) => prev = null);
    }
    const getcarts = async (shipdata) => {
        setLoading(true)
        // if (shipdata?.length) { await shipdata?.map((result) => cartids.push(result?.id)) }        
        let postdata = {}
        const result = shipdata?.map(item => ({
            diamond_id: item?.diamonddetails?.id,
            id: item?.id,
            qty: item?.qty,
            temp_cart_id: item?.temp_cart_id
        }));

        // shipdata?.map((result) => {
        //     if (result?.diamonddetails) {
        //         details.push(
        //             {
        //                 "id": result?.id,
        //                 "qty": result?.qty,
        //                 "diamond_id": result?.diamonddetails?.diamonddata?.id,
        //                 "diamond_note": result?.diamonddetails?.diamonddata?.note,
        //                 "metal": result?.diamonddetails?.productdiamond?.metal?.value,
        //                 "shape": result?.diamonddetails?.productdiamond?.shape?.shapeId,
        //                 "size": result?.diamonddetails?.productdiamond?.size?._id,
        //                 "stone": result?.diamonddetails?.productdiamond?.stone?.value,
        //                 "pointer": result?.diamonddetails?.productdiamond?.pointer?.label,
        //                 "temp_cart_id": result?.temp_cart_id,
        //                 "custom_design": {
        //                     "engraving_text": result?.custom_design?.customizeText,
        //                     "side": result?.custom_design?.inorout,
        //                     "engraving_position": result?.custom_design?.textposition?.label,
        //                     "engraving_logo": result?.custom_design?.imageFile,
        //                     "font": result?.custom_design?.fonts?.label,
        //                     "logo_position": result?.custom_design?.imgPosition?.label
        //                 },
        //             }
        //         )
        //     } else {
        //         details.push(result)
        //     }
        // })
        try {
            postdata = { "diamond_ids": result }

            let res = await _Api(postdata, `order/getCartDetails`)
            if (res?.statusCode === 200) {
                setLoading(false);
                setcurrency(res?.CURRENCY ? res?.CURRENCY : '$')
                let array = [...res?.data];
                array = array.filter(item => item?.id); 
                array?.map((result) => {
                    return result.qty = parseInt(shipdata.filter(e => e?.id === result?.id)?.[0]?.qty || 0);
                })
                setCartdata(array)
                setLoading(false)
                if (res?.deleted_ids?.length) {
                    shipdata.forEach((result) => {
                        if (!res?.deleted_ids.includes(result?.id)) {
                            let data = []
                            data.push(result)
                            localStorage.setItem('CartItems', JSON.stringify(data));
                        }
                    })
                }
            }
            setLoading(false);
        }
        catch (err) {
            setLoading(false);
            console.log(err, "err")
        }
    }


    const checkcart = (event, data) => {
        if (data?.id) {
            setCheckid((prevChecked) =>
                event.target.checked
                    ? data?.diamond ? [...prevChecked, { id: data?.id, qty: data?.qty, temp_cart_id: data?.temp_cart_id, diamond_id: data?.diamond?.id, price: (parseFloat(data?.UnFormatPrice) + parseFloat(data?.diamond?.UnFormatPrice)) }] : [...prevChecked, { id: data?.id, qty: data?.qty, price: data?.UnFormatPrice }]
                    : prevChecked.filter((item) => item?.id !== data?.id)
            )
        } else {
            let fulldata = []
            if (event.target.checked) {
                cartdata?.forEach((result) => {
                    if (result?.diamond) {
                        fulldata.push({ id: result?.id, qty: result?.qty, temp_cart_id: result?.temp_cart_id, diamond_id: result?.diamond?.id, price: (parseFloat(result?.UnFormatPrice) + parseFloat(result?.diamond?.UnFormatPrice)) })
                    } else {
                        fulldata.push({ id: result?.id, qty: result?.qty, price: result?.UnFormatPrice })
                    }
                });

            }
            setCheckid(fulldata)
        }
    }

    const handleClearAll = () => {
        if (checkid.length === cartdata.length) {
            let setupdatearray = [];
            setCartdata((prev) => []);
            setCheckid((prev) => []);
            localStorage.setItem('CartItems', JSON.stringify(setupdatearray));
        }
    }
    const negvigatecheckout = (lable, data) => {
        if (lable === "checkout") {
            navigate("/shipping", { state: { checkoutItems: data } })
        }
        if (lable === "appoinment") {
            navigate("/appointment", { state: { checkoutItems: data } })
        }
    }
    useEffect(() => {
        getcarts(shipdata)
        // eslint-disable-next-line
    }, [])

    const showDeleteConfirmation = () => {

        setIsPopupVisible(true);
    }

    const handleConfirm = (id) => {
        console.log(id, "id handle confirm")
        console.log(singleDeleteItem, "Check Single Delete Item")
        if (checkid?.length === cartdata?.length) {
            handleClearAll();
            console.log("all")
        } else {
            deleteItems(singleDeleteItem?.id);
            console.log("one by one")
        }
        setIsPopupVisible(false);
    };

    const handleCancel = () => {
        setIsPopupVisible(false);
    };

    const handleBookAppointment = () => {
        console.log(checkid, "check id items")
        navigate("/appointment", { state: { checkoutItems: checkid } })
    }

    const downloadPageAsPNG = () => {
        const rootElement = document.getElementById('shoppingcart');
        html2canvas(rootElement).then((canvas) => {
            const imageURL = canvas.toDataURL('image/png');
            const anchor = document.createElement('a');
            anchor.download = 'shoppingcart.png';
            anchor.href = imageURL;
            anchor.click();
        });
    };
    const handlePrint = () => {
        window.print();
    };


    return (
        <div className=' ecommerce-main-layout-bodyContent' id="shoppingcart">
            <div className='cart_page'>
                <div className='cart_page-header'>
                    <span>{t("Home")}</span> <span><RightArrow /></span> <span>{t("Cart")}</span>
                </div>
                <div className='cart_page-headBox'>
                    <span className='cart_page-headBox-heading'>{screenSize.width > 525 ? t("My Shopping Cart") : t("Shopping Cart")} {cartdata?.length ? `(${cartdata?.length} Item)` : null}</span>
                    <div className='cart_page-headBox-icons'>
                        <span className='shareIcon'><ShareIcon type="new" /><span className='tooltip-data'><span><ShareIcon type="threepoint" /></span><span><MessageIcon type="email" /></span></span></span>
                        <span onClick={() => downloadPageAsPNG()}><DownloadIcon color={"#767676"} /></span>
                        <span onClick={() => handlePrint()}><PrintIcon color={"#767676"} /></span>
                    </div>
                </div>
                {loading ? (<div className='h-100 d-flex justify-content-center align-items-center'>

                    <Spinner />

                </div>) : (
                    <>
                        {cartdata?.length ? (
                            <>
                                <div className='cart_page-cartTableBox' >
                                    <div className='w-100'>
                                        <div className='cart_page-cartTableBox-header'>
                                            <div className='cart_page-cartTableBox-header-rightcontent'>
                                                <div className={`cart_page-cartTableBox-header-rightcontent-item ${checkid.length > 0 ? "active" : ""}`}>( {checkid?.length} / {cartdata?.length} {t("Item")} )</div>
                                                <div className={`cart_page-cartTableBox-header-rightcontent-clear ${checkid.length > 0 ? "active" : ""}`} onClick={() => showDeleteConfirmation()}>
                                                    <DeleteIcon type='curved' color={checkid.length === cartdata?.length ? null : '#8A8A8A'} /> {t("Clear All")}
                                                </div>
                                                <div className={`cart_page-cartTableBox-header-rightcontent-appointment ${checkid.length > 0 ? "active" : ""}`} onClick={handleBookAppointment}><span><CalendarIcon width={24} height={24} color={checkid.length > 0 ? "#212121" : "#8A8A8A"} /></span><span className='text'>{t("Book an Appointment")}</span></div>
                                            </div>
                                            <div className='cart_page-cartTableBox-header-wrapper'>
                                                <div className='cart_page-cartTableBox-header-wrapper-left'>
                                                    <div className="ecom-blackthemed-checkbox">
                                                        <input type="checkbox" className="itemscheckbox"
                                                            onChange={(e) => checkcart(e, "")}
                                                            checked={checkid?.length === cartdata?.length}
                                                            id='allcartcheck' />
                                                        <label className="ecom-blackthemed-checkbox-label" htmlFor='allcartcheck'></label>
                                                    </div>
                                                    <span>{t("Product")}</span>
                                                </div>
                                                <div className='cart_page-cartTableBox-header-right'>
                                                    <div className='responsive'>{t("Price")}</div>
                                                    <div className='responsive'>{t("Stock")}</div>
                                                    <div className='responsive'>{t("Quantity")}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div>
                                            {cartdata?.length ? cartdata.map((result, key) => {
                                                console.log(result, "check result form shopping cart")
                                                return (
                                                    <>
                                                        <div className={`cart_page-cartTableBox-content`} key={key}>
                                                            <div className='cart_page-cartTableBox-content-left'>
                                                                <div className='cart_page-cartTableBox-content-left-item'>
                                                                    <div className="ecom-blackthemed-checkbox">
                                                                        <input type="checkbox" className="itemscheckbox"
                                                                            id={result?.id}
                                                                            checked={checkid?.some(item => item.id === result?.id)}

                                                                            onChange={(e) => checkcart(e, result)} />
                                                                        <label className="ecom-blackthemed-checkbox-label cursor-pointer fw-semibold align-items-center"
                                                                            htmlFor={result?.id}
                                                                        >
                                                                        </label>
                                                                    </div>
                                                                    <span onClick={() => { showDeleteConfirmation(); setSingleDeleteItem((prev) => prev = result) }} className='label-icon'>
                                                                        <DeleteIcon type='curved' />
                                                                    </span>

                                                                </div>
                                                                <img className='cart_page-cartTableBox-content-left-item-img' src={result?.main_image} alt='' />
                                                                <div className='cart_page-cartTableBox-content-left-item-detail'>
                                                                    <Link
                                                                        to={result?.diamond ? "/mixandmatch" : `/product/${result?.motherProduct?.Slug}?v=${result?.id}`}
                                                                        state={result?.diamond ? { temp_cart_id: (shipdata.filter((item) => item.id === result?.id)?.[0]?.temp_cart_id), activeTab: 'Product' } : { id: result?.motherProduct?._id }}
                                                                        className='cart_page-cartTableBox-content-left-item-detail-sku'>
                                                                        <span>{result?.SKU ? result?.SKU : "-"}</span><span className='responsive'>{result.price}</span>
                                                                    </Link>
                                                                    <p className='cart_page-cartTableBox-content-left-item-detail-name'>{result.name} </p>
                                                                    <p className='cart_page-cartTableBox-content-left-item-detail-subname'><span className='drops'>{result?.Metal}</span> {result?.stone ? <span className='drops'>{result?.stone}</span> : null} <span className='drops'>#{result?.Size}</span></p>
                                                                    <div className='cart_page-cartTableBox-content-left-item-detail-addtowishlist'><HeartIcon /> {t("Add To Wish List")}</div>
                                                                    <div className='cart_page-cartTableBox-content-left-item-detail-responsive'>
                                                                        <div className='cart_page-cartTableBox-content-left-item-detail-responsive-leftside'>
                                                                            <span>{t("In Stock")}</span>
                                                                            <div className={`cartQuantiyBox cart_page-cartTableBox-content-right-qty-btn ${result?.diamond ? "disabled" : ""}`}>
                                                                                <button disabled={result?.qty > 1 ? false : true} onClick={result?.diamond ? null : () => getQuantity(key, "minus", result?.qty)}>
                                                                                    <MinusIcon width={14} height={14} color={result?.diamond ? "#8A8A8A" : '#1D1D1F'} />
                                                                                </button>
                                                                                <div className='digit'>{result?.qty}</div>
                                                                                <button
                                                                                    onClick={result?.diamond ? null : () => getQuantity(key, "plus", result?.qty)}><PlusIcon width={14} height={14} color={result?.diamond ? "#8A8A8A" : '#1D1D1F'} />
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                        <div className='cartQuantiyBox cart_page-cartTableBox-content-right-price dark'>{result.price}</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className='cartQuantiyBox cart_page-cartTableBox-content-right'>
                                                                <div className='cartQuantiyBox cart_page-cartTableBox-content-right-price dark'>{result?.qty && result?.UnFormatPrice ? `${currency} ${result?.UnFormatPrice*result?.qty}` : result?.price}</div>
                                                                <div className='cartQuantiyBox cart_page-cartTableBox-content-right-price'>{t("In Stock")}</div>
                                                                <div className="cartQuantiyBox cart_page-cartTableBox-content-right-qty">
                                                                    <div className={`cartQuantiyBox cart_page-cartTableBox-content-right-qty-btn ${result?.diamond ? "disabled" : ""}`}>
                                                                        <button disabled={result?.qty > 1 ? false : true} onClick={result?.diamond ? null : () => getQuantity(key, "minus", result?.qty)}>
                                                                            <MinusIcon width={14} height={14} color={result?.diamond ? "#8A8A8A" : '#1D1D1F'} />
                                                                        </button>
                                                                        <div className='digit'>{result?.qty}</div>
                                                                        <button
                                                                            onClick={result?.diamond ? null : () => getQuantity(key, "plus", result?.qty)}><PlusIcon width={14} height={14} color={result?.diamond ? "#8A8A8A" : '#1D1D1F'} />
                                                                        </button>
                                                                    </div>
                                                                    {/* <div className='quantity cursor-pointer' onClick={() => deleteItems(result?.id)}>{t("Remove")}</div> */}
                                                                </div>
                                                                {/* <div className='cartQuantiyBox cart_page-cartTableBox-content-right-total'>
                                                                {toFormatPrice(result.UnFormatPrice * result.qty, { addSymbol: true })}
                                                            </div> */}
                                                            </div>
                                                        </div>
                                                        {
                                                            result?.diamond ?
                                                                <div className="cart_page-cartTableBox-content mixandmatch" key={key + result?.id}>
                                                                    <div className='cart_page-cartTableBox-content-left'>
                                                                        <div className='cart_page-cartTableBox-content-left-item' key={key + result?.id + 1}>
                                                                            <div className="com-ecomCheckBox">
                                                                                <label className="com-ecomCheckBox-labelBox mixandmatch cursor-pointer fw-semibold align-items-center"
                                                                                    htmlFor={result?.id}
                                                                                >
                                                                                    <img className='cart_page-cartTableBox-content-left-item-img' src={result?.diamond?.main_image} alt='' />
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                        <div
                                                                            className='cart_page-cartTableBox-content-left-item-detail'>
                                                                            <p className='cart_page-cartTableBox-content-left-item-detail-name'>{result?.diamond?.name} </p>
                                                                            <Link
                                                                                to={result?.diamond ? "/mixandmatch" : `/product/${result?.motherProduct?.Slug}?v=${result?.id}`}
                                                                                state={result?.diamond ? { temp_cart_id: (shipdata.filter((item) => item.id === result?.id)?.[0]?.temp_cart_id), activeTab: 'Diamond' } : { id: result?.motherProduct?._id }}
                                                                                className='cart_page-cartTableBox-content-left-item-detail-sku'>
                                                                                {result?.diamond?.SKU ? result?.diamond?.SKU : "-"}
                                                                            </Link>
                                                                            <div className='cart_page-cartTableBox-content-left-item-detail-responsive'>
                                                                                <div className='cart_page-cartTableBox-content-left-item-detail-responsive-leftside'>
                                                                                    <span>{t("In Stock")}</span>
                                                                                    <div className={`cartQuantiyBox cart_page-cartTableBox-content-right-qty-btn ${result?.diamond ? "disabled" : ""}`}>
                                                                                        <button disabled={result?.qty > 1 ? false : true} onClick={result?.diamond ? null : () => getQuantity(key, "minus", result?.qty)}>
                                                                                            <MinusIcon width={14} height={14} color={result?.diamond ? "#8A8A8A" : '#1D1D1F'} />
                                                                                        </button>
                                                                                        <div className='digit'>{result?.qty}</div>
                                                                                        <button
                                                                                            onClick={result?.diamond ? null : () => getQuantity(key, "plus", result?.qty)}><PlusIcon width={14} height={14} color={result?.diamond ? "#8A8A8A" : '#1D1D1F'} />
                                                                                        </button>
                                                                                    </div>
                                                                                </div>
                                                                                <div className='cartQuantiyBox cart_page-cartTableBox-content-right-price dark'>{result?.diamond?.price}</div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div className='cartQuantiyBox cart_page-cartTableBox-content-right'>
                                                                        <div className='cartQuantiyBox cart_page-cartTableBox-content-right-price dark'>{result?.diamond?.price}</div>
                                                                        <div className='cartQuantiyBox cart_page-cartTableBox-content-right-price'>{t("In Stock")}</div>
                                                                        <div className="cartQuantiyBox cart_page-cartTableBox-content-right-qty">
                                                                            <div className={`cartQuantiyBox cart_page-cartTableBox-content-right-qty-btn ${result?.diamond ? "disabled" : ""}`}>
                                                                                <button disabled={result?.qty > 1 ? false : true} onClick={result?.diamond ? null : () => getQuantity(key, "minus", result?.qty)}>
                                                                                    <MinusIcon width={14} height={14} color={result?.diamond ? "#8A8A8A" : '#1D1D1F'} />
                                                                                </button>
                                                                                <div className='digit'>{result?.qty}</div>
                                                                                <button
                                                                                    onClick={result?.diamond ? null : () => getQuantity(key, "plus", result?.qty)}><PlusIcon width={14} height={14} color={result?.diamond ? "#8A8A8A" : '#1D1D1F'} />
                                                                                </button>
                                                                            </div>
                                                                            {/* <div className='quantity cursor-pointer' onClick={() => deleteItems(result?.id)}>{t("Remove")}</div> */}
                                                                        </div>
                                                                        {/* <div className='cartQuantiyBox cart_page-cartTableBox-content-right-total'>
                                                                {toFormatPrice(result.UnFormatPrice * result.qty, { addSymbol: true })}
                                                            </div> */}
                                                                    </div>
                                                                </div>
                                                                : ""}
                                                    </>
                                                )
                                            }) : ""}

                                        </div>
                                    </div>
                                    <div className='cart_page-cartTableBox-right'>
                                        <div className='cart_page-cartTableBox-right-head'>{t("ORDER SUMMARY")}</div>
                                        <div className='cart_page-cartTableBox-right-content'>
                                            <div className='cart_page-cartTableBox-right-content-one'>
                                                <span>{t("Subtotal")} {checkid?.length ? `(${checkid?.length} ${t("Items")})` : ""}</span>
                                                <span>
                                                    {checkid.length > 0 && checkid.length !== cartdata.length ?

                                                        toFormatPrice(
                                                            checkid.reduce((accumulator, product) => {
                                                                return accumulator + (product.price * (product.qty));
                                                            }, 0),
                                                            { addSymbol: true }
                                                        )

                                                        :
                                                        toFormatPrice(
                                                            cartdata.reduce((accumulator, product) => {
                                                                // Check if the product has the 'diamond' key
                                                                if (product.diamond) {
                                                                    return accumulator + (parseFloat(product?.UnFormatPrice) + parseFloat(product?.diamond?.UnFormatPrice))
                                                                } else {
                                                                    // Otherwise, multiply price by qty and add to accumulator
                                                                    return accumulator + (product.UnFormatPrice * (product.qty));
                                                                }
                                                            }, 0),
                                                            { addSymbol: true }
                                                        )
                                                    }
                                                </span>
                                            </div>
                                            <div className='cart_page-cartTableBox-right-content-two'>
                                                <span>{t("Total")}</span>
                                                <span>
                                                    {checkid.length > 0 && checkid.length !== cartdata.length ?

                                                        toFormatPrice(
                                                            checkid.reduce((accumulator, product) => {
                                                                return accumulator + (product.price * (product.qty));
                                                            }, 0),
                                                            { addSymbol: true }
                                                        )

                                                        :
                                                        toFormatPrice(
                                                            cartdata.reduce((accumulator, product) => {
                                                                // Check if the product has the 'diamond' key
                                                                if (product.diamond) {
                                                                    // If 'diamond' key exists, add the price directly
                                                                    return accumulator + (parseFloat(product?.UnFormatPrice) + parseFloat(product?.diamond?.UnFormatPrice))
                                                                } else {
                                                                    // Otherwise, multiply price by qty and add to accumulator
                                                                    return accumulator + (product.UnFormatPrice * (product.qty));
                                                                }
                                                            }, 0),
                                                            { addSymbol: true }
                                                        )
                                                    }
                                                </span>
                                            </div>
                                        </div>
                                        <div className='cart_page-cartTableBox-right-subdata'>{t("Tax included and shipping calculated at checkout")}</div>
                                        <button className={`cart_page-cartTableBox-right-button ${checkid?.length > 0 ? '' : 'disabled'}`} onClick={checkid?.length > 0 ? () => negvigatecheckout("checkout", checkid) : null}>{t("Proceed to Checkout")}</button>
                                    </div>
                                </div>
                                {/* <div className='cart_page-cartFooterbox'>
                                    <div className='cart_page-cartFooterbox-subTotalBox'>
                                        <p className=''>{t("SubTotal")}</p>
                                        <p> 
                                            {toFormatPrice(cartdata.reduce(
                                            (accumulator, product) => accumulator + product.UnFormatPrice * product?.qty,
                                            0), { addSymbol: true }
                                            )}
                                        </p>
                                    </div>
                                </div>
                                {checkid?.length ? <div className='com-confirmPurchasePage-main-footerBox mb-4'>
                                    <button className='com-confirmPurchasePage-main-footerBox-completeBtn' onClick={() => negvigatecheckout("checkout", checkid)}>{t("Checkout")}</button>
                                    <button className='com-confirmPurchasePage-main-footerBox-completeBtn' onClick={() => negvigatecheckout("appoinment", checkid)} >{t("Appointment")}</button>
                                </div> : ""} */}
                            </>
                        ) : (
                            <>
                                <div className='cart_page-nodata'>
                                    <p className='cart_page-nodata-subhead'>{t("There are no items in your cart")}. <Link to="/collection" className='cart_page-nodata-text'><span>{t("Continue Shopping")} <RightArrow /></span></Link></p>
                                </div>
                            </>
                        )}

                    </>)}

            </div>
            <Deletedeletepopup
                isVisible={isPopupVisible}
                onConfirm={handleConfirm}
                onCancel={handleCancel}
                message="Remove Items"
            />
            <BottomBar />
        </div>
    )
}
